import React, {useEffect, useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import {LoginContext} from "../context/loginContext";

const Protected = ({Component}) => {
    const navigate = useNavigate();
    const [userLogin, ] = useContext(LoginContext);
    useEffect(() => {
        if (userLogin) navigate('/admin/home');
        else navigate('/login');
    }, []);
    return (
        <Component/>
    );
};

export default Protected;
